import HeroSection from "./HeroSection"
import Socialize from "./Socialize"
import Connected from "./Connected"
import HowItWorks from "./HowItWorks"
import Reviews from "./Reviews"
import GetReady from "./GetStarted"
function Main() {
  return (
    <div>
    <HeroSection />
    <Socialize />
    <Connected />
    <HowItWorks />
    <Reviews />
    <GetReady />
    </div>
  )
}

export default Main